"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LANDING_PAGE_SKELETON = void 0;
const LANDING_PAGE_SKELETON = exports.LANDING_PAGE_SKELETON = 'landing-page-skeleton';
